// extracted by mini-css-extract-plugin
module.exports = {"container":"VerificationRadio_container__DrutM","radio":"VerificationRadio_radio__uwuvj","label":"VerificationRadio_label__NoshF"};